<style lang="scss" scoped>
.login-wrapper {
  display: flex;
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
}

/* ── Left panel ── */
.login-brand {
  flex: 1;
  background: linear-gradient(160deg, #0d1b3e 0%, #1a3a7a 55%, #389ad4 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 56px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.06);
    top: -80px;
    right: -120px;
  }
  &::after {
    content: '';
    position: absolute;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.06);
    bottom: -60px;
    left: -60px;
  }

  .brand-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    padding: 6px 14px;
    color: #ffb870;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin-bottom: 40px;
  }

  .brand-icon {
    width: 72px;
    height: 72px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;

    svg {
      width: 40px;
      height: 40px;
      fill: #fff;
      opacity: 0.9;
    }
  }

  .brand-logo {
    max-width: 180px;
    margin-bottom: 24px;
  }

  h1 {
    color: #fff;
    font-size: 36px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 16px;
    letter-spacing: -0.5px;
  }

  p {
    color: rgba(255, 255, 255, 0.65);
    font-size: 15px;
    line-height: 1.7;
    max-width: 340px;
    margin-bottom: 48px;
  }

  .brand-features {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;

      .check {
        width: 24px;
        height: 24px;
        min-width: 24px;
        background: rgba(245, 128, 32, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffb870;
        font-size: 12px;
      }
    }
  }
}

/* ── Right panel ── */
.login-form-panel {
  width: 480px;
  min-width: 480px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;

  .form-inner {
    width: 100%;
    max-width: 380px;
  }

  .form-header {
    margin-bottom: 36px;

    .form-eyebrow {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #389ad4;
      margin-bottom: 8px;
    }

    h2 {
      font-size: 26px;
      font-weight: 700;
      color: #0d1b3e;
      margin: 0 0 6px;
    }

    p {
      font-size: 14px;
      color: #7a8499;
      margin: 0;
    }
  }

  .field-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #4a5568;
    margin-bottom: 6px;
    display: block;
  }

  .field-wrap {
    position: relative;
    margin-bottom: 20px;

    input {
      width: 100%;
      height: 48px;
      border: 1.5px solid #dde2ec;
      border-radius: 10px;
      padding: 0 44px 0 14px;
      font-size: 14px;
      color: #0d1b3e;
      background: #fff;
      outline: none;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #389ad4;
        box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.12);
      }

      &.is-invalid {
        border-color: #e53e3e;
        box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);
      }
    }

    .toggle-pw {
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      color: #7a8499;
      background: none;
      border: none;
      padding: 0;
      display: flex;
      align-items: center;

      &:hover { color: #1565c0; }
    }
  }

  .field-error {
    font-size: 12px;
    color: #e53e3e;
    margin-top: -14px;
    margin-bottom: 16px;
  }

  .forgot-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 28px;

    a {
      font-size: 13px;
      color: #389ad4;
      cursor: pointer;
      text-decoration: none;
      font-weight: 500;

      &:hover { text-decoration: underline; }
    }
  }

  .btn-signin {
    width: 100%;
    height: 50px;
    background: linear-gradient(135deg, #e06a10, #F58020);
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.4px;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover { opacity: 0.92; transform: translateY(-1px); }
    &:active { transform: translateY(0); }
    &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

    .spinner-border {
      width: 16px;
      height: 16px;
      border-width: 2px;
    }
  }

  .alert-error {
    background: #fff5f5;
    border: 1px solid #feb2b2;
    color: #c53030;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 13px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .login-wrapper { flex-direction: column; }
  .login-brand { padding: 40px 28px; display: none; }
  .login-form-panel {
    width: 100%;
    min-width: unset;
    min-height: 100vh;
  }
}
</style>

<template>
  <div class="login-wrapper">
    <!-- Left: brand panel -->
    <div class="login-brand">
      <div class="brand-badge">
        <i class="fa fa-shield"></i>
        Secure Portal
      </div>

      <div class="brand-icon" v-if="!getServiceProviderData || !getServiceProviderData.image && !getServiceProviderData.logo">
        <!-- Fingerprint SVG -->
        <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 4C19.3 4 9 14.3 9 27c0 5.1 1.6 9.8 4.4 13.6M32 4c12.7 0 23 10.3 23 23 0 5.1-1.6 9.8-4.4 13.6M32 4v0M20 27c0-6.6 5.4-12 12-12s12 5.4 12 12c0 3.4-1.4 6.4-3.6 8.6M20 27c0-3.4 1.4-6.4 3.6-8.6M26 27c0-3.3 2.7-6 6-6s6 2.7 6 6c0 1.8-.8 3.4-2 4.5M26 27c0-1.8.8-3.4 2-4.5M32 27v12M32 46v6M13 41l4-4M47 41l-4-4" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </div>

      <img
        v-if="getServiceProviderData && (getServiceProviderData.image || getServiceProviderData.logo)"
        :src="getServiceProviderData.image || getServiceProviderData.logo"
        class="brand-logo"
        alt="logo"
      />

      <h1>Biometric Identity<br />Services Portal</h1>
      <p>Secure scheduling and processing for FBI background checks, FD-258 fingerprint cards, and FDLE submissions.</p>

      <ul class="brand-features">
        <li>
          <span class="check"><i class="fa fa-check"></i></span>
          FBI Background Check Processing
        </li>
        <li>
          <span class="check"><i class="fa fa-check"></i></span>
          FD-258 Fingerprint Card Submissions
        </li>
        <li>
          <span class="check"><i class="fa fa-check"></i></span>
          FDLE Biometric Enrollment
        </li>
        <li>
          <span class="check"><i class="fa fa-check"></i></span>
          Appointment Scheduling & Management
        </li>
      </ul>
    </div>

    <!-- Right: form panel -->
    <div class="login-form-panel">
      <div class="form-inner">
        <div class="form-header">
          <div class="form-eyebrow">Authorized Personnel Only</div>
          <h2>Welcome Back</h2>
          <p>Sign in to your account to continue</p>
        </div>

        <div class="alert-error" v-if="errorMsg">
          <i class="fa fa-exclamation-circle"></i>
          {{ errorMsg }}
        </div>

        <form @submit.stop.prevent="onSubmit">
          <div>
            <label class="field-label">Username</label>
            <div class="field-wrap">
              <input
                type="text"
                v-model="username"
                :class="{ 'is-invalid': errors['username'] && username == '' }"
                autocomplete="username"
              />
            </div>
            <div class="field-error" v-if="errors['username'] && username == ''">
              {{ errors['username'] }}
            </div>
          </div>

          <div>
            <label class="field-label">Password</label>
            <div class="field-wrap">
              <input
                :type="password_type"
                v-model="password"
                :class="{ 'is-invalid': errors['password'] && password == '' }"
                autocomplete="current-password"
              />
              <button type="button" class="toggle-pw" @click="showPassword()">
                <i :class="showPasswordIcon ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button>
            </div>
            <div class="field-error" v-if="errors['password'] && password == ''">
              {{ errors['password'] }}
            </div>
          </div>

          <div class="forgot-row">
            <a @click="forgotPassword()">Forgot password?</a>
          </div>

          <button type="submit" class="btn-signin" ref="kt_login_signin_submit">
            Sign In
            <i class="fa fa-arrow-right"></i>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LOGIN,
  LOGOUT,
  FETCH_SERVICE_PROVIDER_DATA
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      errorMsg: "",
      username: "",
      password: "",
      showPasswordIcon: false,
      password_type: "password",
      client_slug: "",
      errors: []
    };
  },
  created() {
    if (this.$route.query.s) {
      this.client_slug = this.$route.query.s;
      this.$store.dispatch(FETCH_SERVICE_PROVIDER_DATA, {
        client_slug: this.client_slug,
        fetch_slug: "f",
        reset_token: "none"
      });
    }
  },
  computed: {
    ...mapGetters(["getServiceProviderData"])
  },
  methods: {
    showPassword() {
      this.showPasswordIcon = !this.showPasswordIcon;
      this.password_type = this.showPasswordIcon ? "text" : "password";
    },
    forgotPassword() {
      this.$router.push({
        name: "client.password.reset",
        params: { client_slug: this.$route.params.client_slug }
      });
    },
    onSubmit() {
      this.errors = [];
      this.errorMsg = "";

      if (!this.username) this.errors.username = "This field is required";
      if (!this.password) this.errors.password = "This field is required";
      if (!this.username || !this.password) return;

      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.disabled = true;

      this.$store.dispatch(LOGOUT);
      this.$store
        .dispatch(LOGIN, {
          username: this.username,
          password: this.password,
          client_slug: this.client_slug
        })
        .then(data => {
          if (data.user.is_admin == 0) {
            this.$router.push({ name: "client.dashboard", params: { client_slug: data.slug } });
          } else {
            this.$router.push({ name: "admin.dashboard" });
          }
        })
        .catch(() => {
          this.errorMsg = "Invalid username or password";
          submitButton.disabled = false;
        });
    }
  }
};
</script>
